module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "children-head"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._t("back"), _vm._v(" "), _vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "template"
  }, [_vm._t("template")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search"
  }, [(_vm.moduleName == 'workOrder') ? [_c('el-input', {
    staticClass: "input-text",
    attrs: {
      "placeholder": '请输入' + _vm.selectLable
    },
    nativeOn: {
      "change": function($event) {
        return _vm.searchKeydown($event)
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "工单编号",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "合同",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "客户",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "机会",
      "value": "5"
    }
  })], 1)], 1), _vm._v(" "), (_vm.search) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.clearValue
    }
  }) : _vm._e()] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "change": _vm.searchKeydown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.search) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.clearValue
    }
  }) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_vm._t("options"), _vm._v(" "), _vm._t("otherBtn")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-494d3e37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/list-head.vue
// module id = 1264
// module chunks = 82